// Identifica registros de exceção referentes a Certificado do Portal,
// verificando tanto a classe quanto a mensagem do registro.
export function isCertificadoPortal(registro) {
  const texto = `${registro?.classe || ''} ${registro?.mensagem || ''}`.toUpperCase();
  return texto.includes('CERTIFICADO_PORTAL');
}
